export default {
    state: {
        requisites: null,
        requisitesFile: null,
        isRequisitesFormOpened: false,
        isRequisitesFormPassed: false
    },
    getters: {
        isRequisitesFile(state) {
            return !!state.requisitesFile?.type
        },
        isRequisitesFormOpened(state) {
            return state.isRequisitesFormOpened
        },
        isRequisitesFormPassed(state) {
            return state.isRequisitesFormPassed
        },
        isRequisitesFormComplete(state, getters) {
            return !!state.requisites?.companyLongName &&
                !!state.requisites?.companyShortName &&
                !!state.requisites?.juridicAddress &&
                !!state.requisites?.INN &&
                !!state.requisites?.KPP &&
                !!state.requisites?.OGRN &&
                !!state.requisites?.payment_account &&
                !!state.requisites?.correspondent_account &&
                !!state.requisites?.bank &&
                !!state.requisites?.BIK &&
                !!state.requisites?.director &&
                !!state.requisites?.act_base &&
                !!state.requisites?.phone &&
                !!state.requisites?.email ||
                !!getters.isRequisitesFile
        },
        // getFinalRequisites(state, getters) {
        //     return getters.isRequisitesFile? state.requisitesFile : state.requisites
        // }
    },
    mutations: {
        setRequisites(state, payload) {
            state.requisites = payload
        },
        setRequisitesFile(state, payload) {
            state.requisitesFile = payload
        },
        setIsRequisitesFormOpened(state, payload) {
            typeof payload === 'boolean' && (state.isRequisitesFormOpened = payload)
        },
        setIsRequisitesFormPassed(state, payload) {
            typeof payload === 'boolean' && (state.isRequisitesFormPassed = payload)
        }
    }
}
